import { Chip } from '@mui/material';
import { forwardRef } from 'react';
import {
    PROCESSED_TIMESHEET_STATUS_COLORS,
    PROCESSED_TIMESHEET_STATUS_LABELS,
} from '../../Admin/constants';

const StatusPill = forwardRef(
    ({ content, variant = 'lt-admin-pill', status, sx, ...rest }, ref) => (
        <Chip
            ref={ref}
            variant={variant}
            label={content || PROCESSED_TIMESHEET_STATUS_LABELS[status] || status}
            color={PROCESSED_TIMESHEET_STATUS_COLORS[status] || 'default'}
            sx={{
                justifyContent: 'flex-start',
                '& .MuiChip-label': {
                    display: 'flex',
                    flexGrow: 1,
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    rowGap: 2,
                },
                ...(sx || {}),
            }}
            {...rest}
        />
    )
);

export default StatusPill;
